function goToMarker(data) {
    const marker = window.markers.find(m => m.id == (data.id || 16));
    window.google.maps.event.trigger(marker.marker, 'click');

    window.map.setZoom(8);
    window.map.setCenter({lat: data.lat, lng: data.lng});
}

export { goToMarker };